import { MDXProvider } from '@mdx-js/react';

import '../styles/reset.css';

import { CompanyQuote } from './company/CompanyQuote';
import { CompanySection } from './company/CompanySection';
import { CompanySectionTop } from './company/CompanySectionTop';
import { Quote } from './generic/Quote';
import { VimeoEmbed } from './generic/VimeoEmbed';
import { Footer } from './Footer';
import { Header, HeaderProps } from './header/Header';
import { HighlightText } from './company/HighlightText';

export interface LayoutProps extends HeaderProps {
  /**
   * Layout content
   */
  children: React.ReactNode;
  /**
   * Content class name
   */
  contentClassName?: string;
}

const shortcodes = { CompanyQuote, CompanySection, CompanySectionTop, HighlightText, Quote, VimeoEmbed };

export const Layout = (
  {
    children,
    isHomePage,
    darkLogo,
    headerClassName,
    contentClassName,
  } : LayoutProps,
) => (
  <MDXProvider components={shortcodes}>
    <Header isHomePage={isHomePage} headerClassName={headerClassName} darkLogo={darkLogo} />
    <div className={contentClassName}>
      <main className={contentClassName && `${contentClassName}-main`}>
        {children}
      </main>
    </div>
    <Footer />
  </MDXProvider>
);
